import React from 'react';
import PropTypes from 'prop-types';

import RichText from 'dpl/prismic/components/RichText';
import { get } from 'dpl/shared/utils/object';
import SmartImage from 'dpl/components/SmartImage';
import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';

import { ARTICLE_CONTENT_COL_CLASSES } from '../utils/constants';

const AUTHOR_IMAGE_DIAMETER = '64px';

export default function Quote({ sliceData }) {
  const headline = get(sliceData, 'primary.headline');
  const quoteImage = get(sliceData, 'primary.image');
  const content = get(sliceData, 'primary.content');

  return (
    <div className="PrismicQuote container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <div className="flex mb5">
            {quoteImage && quoteImage.url && (
              <SmartImage
                Tag="div"
                src={quoteImage.url}
                width={AUTHOR_IMAGE_DIAMETER}
                height={AUTHOR_IMAGE_DIAMETER}
                className="bg-center cover mr4"
                lazy
              />
            )}
            {headline && (
              <p className="PrismicQuote__headline b f4-md">{headline}</p>
            )}
          </div>
          {get(content, '0.text') && (
            <div className="relative">
              <span className="PrismicQuote__arrow absolute" />
              <div className="bg-lightest-blue pv4 ph4 pv8-sm ph8-sm br2">
                <RichText content={content} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

Quote.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      content: StructuredTextPropTypes,
      headline: PropTypes.string.isRequired,
      image: PropTypes.shape({
        url: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};
